export default __webpack_public_path__ + "static/devsecops-transform-01c2c2dff39b34ad755b8070dedce3f2.png";